var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnhanceProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13161",
    "data-name": "Group 13161",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.382,
    height: 22,
    viewBox: "0 0 18.382 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4849",
    "data-name": "Rectangle 4849",
    width: 18.382,
    height: 22,
    fill: "#014fe0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12142",
    "data-name": "Group 12142",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45194",
    "data-name": "Path 45194",
    d: "M14.96,208.642H3.4c-3.592-.5-3.7-3.558-3.166-6.5.439-2.4,1.745-4.93,4.56-4.891.57.008,1.479.8,2.014,1.083a4.987,4.987,0,0,0,4.854-.059c.524-.288,1.352-1.024,1.94-1.024,3.9,0,4.977,4.928,4.748,8.013a3.631,3.631,0,0,1-3.393,3.373",
    transform: "translate(0 -186.642)",
    fill: "#014fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45195",
    "data-name": "Path 45195",
    d: "M80.189,5.3a5.3,5.3,0,1,1-5.3-5.3,5.3,5.3,0,0,1,5.3,5.3",
    transform: "translate(-65.842 -0.001)",
    fill: "#014fe0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhanceProfileIcon);
export default __webpack_public_path__ + "static/media/enhance-profile-icon.3014f8483450840c1912cc6f3cda250e.svg";
export { ForwardRef as ReactComponent };